var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import { css as emotionCss, cx } from 'emotion';
import { Icon } from '@citrus/icon';
import { getAutomation, getDebug } from '@citrus/runtime';
import { Tooltip } from '@citrus/tooltip';
import { isNotNullOrEmpty } from '@pcty/utils';
import { Outlier as OutlierYellow, OutlierGreen, OutlierPurple, OutlierRed, OutlierContent, OutlierDetected as OutlierDetectedYellow, OutlierDetectedGreen, OutlierDetectedPurple, OutlierDetectedRed, OutlierDetectedText, } from '../Table.styled';
import { outlierHover } from '../../styles/legacy';
var VERSION = 'unknown';
/** Special information for the component in the documentation goes here. */
var Outlier = function (_a) {
    var _b;
    var automationId = _a.automationId, children = _a.children, color = _a.color, icon = _a.icon, onClick = _a.onClick, _c = _a.text, text = _c === void 0 ? 'Outlier Detected' : _c, tooltip = _a.tooltip, _d = _a.__TYPE, TYPE = _d === void 0 ? 'Outlier' : _d, other = __rest(_a, ["automationId", "children", "color", "icon", "onClick", "text", "tooltip", "__TYPE"]);
    var tooltipId = useState(new Date().getTime().toString())[0];
    var Outlier;
    var OutlierDetected;
    var classes = cx((_b = {},
        _b[emotionCss(outlierHover)] = isNotNullOrEmpty(onClick),
        _b));
    switch (color) {
        case 'yellow':
        default:
            Outlier = OutlierYellow;
            OutlierDetected = OutlierDetectedYellow;
            break;
        case 'green':
            Outlier = OutlierGreen;
            OutlierDetected = OutlierDetectedGreen;
            break;
        case 'purple':
            Outlier = OutlierPurple;
            OutlierDetected = OutlierDetectedPurple;
            break;
        case 'red':
            Outlier = OutlierRed;
            OutlierDetected = OutlierDetectedRed;
            break;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Outlier, __assign({}, other, getAutomation(automationId), getDebug(sessionStorage.getItem('citrus-debug') === 'true', TYPE, VERSION), { className: classes, "data-citrus-tooltip": tooltipId, onClick: onClick }),
            React.createElement(OutlierContent, null, children),
            React.createElement(OutlierDetected, null,
                icon || React.createElement(Icon, { name: "exclamation-circle", title: text }),
                React.createElement(OutlierDetectedText, null, text))),
        isNotNullOrEmpty(tooltip) && (React.createElement(Tooltip, { id: tooltipId, location: "auto", portal: true }, tooltip))));
};
Outlier.defaultProps = {
    __TYPE: 'Outlier',
};
export default Outlier;
